import { BaseMutations } from '@/store/base-mutations';
import PatchNotesState from './state';
import { Patchnotes } from '../types';

export default class PatchNotesMutations extends BaseMutations<PatchNotesState> {
  SET_PATCH_NOTES(patchnotes: Patchnotes.PatchNote[]) {
    this.state.patch_notes = patchnotes;
  }
}
